import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
import { useSelector } from 'react-redux';
import { useAction } from 'hooks';
import Button from 'components/Form/Button';
import DataSources from 'modules/DataSources';
import * as actions from '../../actions';
import * as selectors from '../../selectors';
import messages from '../../messages';
const ReauthorizeContourCloudButton = ()=>{
    const externalDataSources = useSelector(DataSources.selectors.dataSources);
    const connectedDataSources = useSelector(DataSources.selectors.connectedDataSources);
    const isInProgress = useSelector(selectors.isReauthContourCloudInProgress);
    const onReauthContourCloud = useAction(actions.reauthContourCloud);
    const ccDataSource = externalDataSources.find((eds)=>eds.dataSourceProvider === DataSources.constants.DATA_SOURCES_TYPE_NAME.CONTOUR_CLOUD);
    if (!ccDataSource) return null;
    const ccConnectedDataSource = connectedDataSources.find((cds)=>cds.externalDataSourceId === ccDataSource.externalDataSourceId);
    if (!ccConnectedDataSource) return null;
    return /*#__PURE__*/ _jsx(Button, {
        styleModifier: "primary",
        className: "btn--filled mt-4",
        labelMessage: messages.buttons.reauthContourCloud,
        onClick: onReauthContourCloud,
        isInProgress: isInProgress
    });
};
export default ReauthorizeContourCloudButton;
